function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M233.9 162.8C233.9 93.9 141.7 0 141.7 0S49.6 93.9 49.6 162.8c0 56.9 33.7 86.5 78 91.5v29.1h28.3v-29.1c44.2-5.1 78-34.6 78-91.5zm-157.8 0c0-22.1 14.5-54.5 40.7-91.2 3.6-5.1 7.3-9.9 10.8-14.5v170.5c-23.6-3.5-51.5-17.6-51.5-64.8zm79.8 64.8V57.1c3.4 4.4 6.9 9 10.4 13.9 26.5 36.9 41.1 69.5 41.1 91.8 0 47.2-27.9 61.3-51.5 64.8z"
})));